<template>
  <div>
    <div
      v-if="duplicateScroll"
      class="table-responsive"
      ref="scrollTableTop"
      @scroll.passive="handleScrollTableTop"
    >
      <div ref="tableTop" style="height: 10px"></div>
    </div>
    <div
      class="table-responsive"
      :class="containerClass"
      @scroll.passive="handleScrollTable"
      ref="scrollTable"
    >
      <table
        class="table table-bordered table-sm"
        :class="tableClass"
        ref="table"
      >
        <thead class="table-secondary">
          <tr>
            <TableTh
              v-for="column in columns"
              :key="column.key"
              :column="column"
            >
              <slot :name="`head${column.key}`" :column="column"></slot>
            </TableTh>
          </tr>
        </thead>
        <slot name="tbody" :rows="rowsPerPage">
          <tbody>
            <slot name="rows" :rows="rowsPerPage">
              <tr v-for="row in rowsPerPage" :key="row[columnID]">
                <td
                  v-for="column in columns"
                  :key="column.value"
                  :class="column.row_class || ''"
                >
                  <slot
                    :name="`row${column.key}`"
                    :row="row"
                    :val="row[column.key]"
                    >{{ row[column.key] }}</slot
                  >
                </td>
              </tr>
            </slot>
          </tbody>
        </slot>
        <slot name="tfooter" />
      </table>
    </div>
    <template v-if="pagination">
      <BPagination
        class="mt-5"
        v-model="inner.page"
        :total-rows="rows.length"
        :per-page="perPage"
        first-number
        last-number
        :limit="6"
        align="center"
      ></BPagination>
    </template>
  </div>
</template>
<script>
import TableTh from "./TableTh.vue";
import { BPagination } from "bootstrap-vue";

export default {
  components: { TableTh, BPagination },
  props: {
    containerClass: {
      type: String
    },
    tableClass: {
      type: String
    },
    rows: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    columnID: {
      type: String,
      required: true
    },
    pagination: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 15
    },
    page: {
      type: Number,
      default: 1
    },
    duplicateScroll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inner: {
        page: this.page
      },
      scrolling: false
    };
  },
  computed: {
    rowsPerPage() {
      if (!this.pagination) return this.rows;

      const tempRows = [...this.rows];

      return tempRows.slice(
        (this.inner.page - 1) * this.perPage,
        this.inner.page * this.perPage
      );
    }
  },
  watch: {
    "inner.page": {
      handler(val) {
        this.$emit("paginate", {
          page: val,
          rows: [...this.rowsPerPage]
        });
      },
      immediate: true
    },
    rows(val) {
      this.inner.page = 1;
      this.$nextTick(() => {
        this.$emit("paginate", {
          page: this.inner.page,
          rows: [...this.rowsPerPage]
        });
      });
    }
  },
  updated() {
    this.updateTableTopWidth();
  },
  mounted() {
    this.updateTableTopWidth();
  },
  methods: {
    handleScrollTableTop(e) {
      if (this.scrolling) {
        this.scrolling = false;
        return true;
      }
      this.scrolling = true;

      const { scrollLeft } = e.target;
      const { scrollTable } = this.$refs;
      scrollTable.scrollLeft = scrollLeft;
    },
    handleScrollTable(e) {
      if (!this.duplicateScroll) return;

      if (this.scrolling) {
        this.scrolling = false;
        return true;
      }
      this.scrolling = true;

      const { scrollLeft } = e.target;
      const { scrollTableTop } = this.$refs;
      scrollTableTop.scrollLeft = scrollLeft;
    },
    updateTableTopWidth() {
      if (!this.duplicateScroll) return;

      const { tableTop, table } = this.$refs;
      tableTop.style.width = `${table.offsetWidth}px`;
    }
  }
};
</script>

<style lang="scss" scoped>
.table {
  table-layout: fixed;

  th {
    width: 100%;
    font-weight: 700;
  }

  &-sm {
    th {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
  }
}
</style>
